import React from 'react';
import SecondaryButton from 'src/components/form-components/SecondaryButton/SecondaryButton';
import PrimaryButton from 'src/components/form-components/PrimaryButton/PrimaryButton';
import { defineMessages } from 'react-intl';
import globalMessages from 'src/services/globalMessages';
import { IButtonProps } from 'src/components/form-components/Button/Button';

const messages = defineMessages({
    keepSelected: {
        id: 'keepSelected',
        defaultMessage: 'Maradjon'
    }
})

const getSelectCaption = (isFirstStep?: boolean) =>
    isFirstStep ? globalMessages.firstStepAction : globalMessages.next

interface ISelectButtonProps extends Omit<IButtonProps, 'caption'> {
    selected: boolean;
    isFirstStep: boolean;
}

const SelectButton: React.FC<ISelectButtonProps> = ({ selected, isFirstStep, onClick }) =>
    !selected
        ? <PrimaryButton
            className="calendar-item__select-button"
            caption={getSelectCaption(isFirstStep)}
            onClick={onClick}
        />
        : <SecondaryButton
            className="calendar-item__select-button"
            caption={messages.keepSelected}
            onClick={onClick}
        />

export default SelectButton